import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import {
  toggleNChangeShishe,
  toggleNChangeType,
  toggleNPercentRiyal,
} from "Constants/Constants";
import {
  getGlassList,
  getGroupProductGlass,
  changePriceProductGlassGroup,
  getSpacerList,
  GetAllMahsooleShishe,
} from "Stores/actions";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
let _toggleNChangeType = toggleNChangeType;

function ChangeShishePriceGroup() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { groupGlassList, glassList, spacerList, mahsooleShishePagination } =
    useSelector((state) => ({
      groupGlassList: state.shishe.groupGlassList,
      glassList: state.shishe.glassList,
      spacerList: state.shishe.spacerList,
      mahsooleShishePagination: state.shishe.mahsooleShishePagination,
    }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    typeAction: {
      type: "toggle",
      row: 1,
      arrayItems: toggleNChangeShishe,
      value: toggleNChangeShishe[0],
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    typeGroup: {
      type: "select",
      row: 1,
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    price: {
      type: "price",
      row: 1,
      value: "",
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
      relation: "isPercent",
    },
    isPercent: {
      type: "toggle",
      row: 2,
      relation: "price",
      arrayItems: toggleNPercentRiyal,
      value: toggleNPercentRiyal[0],
      ValidationPlus: {
        isPercent: true,
      },
      validation: {
        required: true,
      },
      col: {
        sm: 4,
        xs: 6,
      },
    },
    changeType: {
      type: "toggle",
      row: 1,
      arrayItems: [],
      value: null,
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });

  useEffect(() => {
    setControls({ typeGroup: { value: glassList[0] } });
    setControls({ typeGroup: { selectItems: glassList } });
  }, [glassList]);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    if (name === "typeAction") {
      if (value.value === 1) {
        setControls({
          typeGroup: {
            selectItems: groupGlassList,
            value: groupGlassList[0],
          },
        });
      } else if (value.value === 2) {
        setControls({
          typeGroup: {
            selectItems: glassList,
            value: glassList[0],
          },
        });
      } else if (value.value === 3) {
        setControls({
          typeGroup: {
            selectItems: spacerList,
            value: spacerList[0],
          },
        });
      }
    }
  };

  useEffect(() => {
    try {
      _toggleNChangeType[0].disabled = controls.isPercent.value.value;
      let _value = controls.changeType.value;
      if (
        controls.isPercent.value.value &&
        _value.value === _toggleNChangeType[0].value
      )
        _value = _toggleNChangeType[1];
      setControls({
        changeType: { arrayItems: _toggleNChangeType, value: _value },
      });
    } catch {
      _toggleNChangeType[0].disabled = false;
      setControls({
        changeType: {
          arrayItems: _toggleNChangeType,
          value: _toggleNChangeType[1],
        },
      });
    }
  }, [controls.isPercent?.value?.value]);

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { typeGroup, price, isPercent, changeType, typeAction } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      if (isPercent.value.value && price.value > 100) {
        showNotify({
          text: t("wrongPercentage"),
          customClass: "error",
        });
      } else {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: typeAction.value.value === 4 ? 0 : typeGroup.value.Id,
            TypeGroup: typeAction.value.value,
            IsPercent: isPercent.value.value,
            TypeAction: +changeType.value.value,
            Value: +price.value,
          };
          await dispatch(changePriceProductGlassGroup(data));
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Limit: mahsooleShishePagination.Limit,
            Page: mahsooleShishePagination.Page,
          };
          await dispatch(GetAllMahsooleShishe(params));
          setLoading(false);
          onClear();
          handleDialog();
        } catch (e) {
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "error",
          });
        }
        handleDialog();
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      await dispatch(getGlassList(params));
      dispatch(getSpacerList(params));
      dispatch(getGroupProductGlass(params));
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onClear = () => {
    setCheckValid(false);
    setFormValid({});
    setControls({ typeAction: { value: toggleNChangeShishe[0] } });
    setControls({ typeGroup: { value: "" } });
    setControls({ price: { value: "" } });
    setControls({ isPercent: { value: toggleNPercentRiyal[0] } });
    _toggleNChangeType[0].disabled = true;
    setControls({
      changeType: {
        arrayItems: _toggleNChangeType,
        value: _toggleNChangeType[1],
      },
    });
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"priceChangeInGroup"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"priceChangeInGroup"} />}</p>
          </div>
          <DialogContent>
            {!loading ? (
              <Grid container spacing={2}>
                {Object.keys(controls)
                  .filter((key) => controls[key].row === 1)
                  .map((key, index) => {
                    return (
                      <Grid
                        item
                        sm={controls[key].col.sm}
                        xs={controls[key].col.xs}
                        key={key + index}
                      >
                        {controls[key].type === "select" && (
                          <MuiAutoComplete
                            loading={loading}
                            options={controls[key].selectItems}
                            label={<Translator id={key} />}
                            value={controls[key].value}
                            id={key}
                            onChange={autoCompleteHandler}
                            disabled={key === "typeGroup" && controls.typeAction.value.value === 4}
                          />
                        )}
                        {controls[key].type === "price" && (
                          <Input
                            setValue={setValue.bind(this)}
                            value={controls[key].value}
                            name={key}
                            placeholder={t(key)}
                            validation={
                              controls[key].relation &&
                              controls[controls[key].relation].value.value
                                ? {
                                    ...controls[key].validation,
                                    ...controls[controls[key].relation]
                                      .ValidationPlus,
                                  }
                                : controls[key].validation
                            }
                            checkValid={checkValid}
                            label={<Translator id={key} />}
                            type={controls[key].type}
                            endIcon={
                              controls.isPercent.value.value ? (
                                "%"
                              ) : (
                                <Translator id="moneyUnit" />
                              )
                            }
                            radioGroup={{
                              name: controls[key].relation,
                              value: controls[controls[key].relation].value,
                              items:
                                controls[controls[key].relation].arrayItems,
                              onChange: onChangeToggle,
                            }}
                          />
                        )}
                        {controls[key].type === "toggle" && (
                          <MuiRadioGroup
                            name={key}
                            value={controls[key].value}
                            items={controls[key].arrayItems}
                            onChange={onChangeToggle}
                            translate={true}
                            className="horizontalRadio"
                          />
                        )}
                      </Grid>
                    );
                  })}
              </Grid>
            ) : (
              <MuiSkeleton xs={6} number={4} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default ChangeShishePriceGroup;
